export default {
    password : 'La password deve contenere almeno 6 caratteri',
    match: 'Le password non coincidono!',
    reset : 'La tua password è stata resettata!',
    sent : 'Ti abbiamo inviato un link per il reset della password sul tuo account mail!',
    token : 'This password reset token is invalid.',
    user : "We cant find a user with that e-mail address.",
    wrong: 'Password or email is incorrect'
}